import { html, render } from 'lit-html';

export class LoadingSpinner extends HTMLElement {
  static get observedAttributes() {
    return ['size', 'color', 'text'];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  private render() {
    const size = this.getAttribute('size') || 'md';
    const color = this.getAttribute('color') || 'blue';
    const text = this.getAttribute('text') || '';

    const sizeClasses = {
      sm: 'h-4 w-4',
      md: 'h-8 w-8',
      lg: 'h-12 w-12',
      xl: 'h-16 w-16'
    };

    const colorClasses = {
      blue: 'text-blue-600',
      gray: 'text-gray-600',
      white: 'text-white',
      emerald: 'text-emerald-600'
    };

    const template = html`
      <div class="flex flex-col items-center justify-center space-y-2">
        <div class="animate-spin ${sizeClasses[size as keyof typeof sizeClasses]} ${colorClasses[color as keyof typeof colorClasses]}">
          <svg fill="none" viewBox="0 0 24 24" class="w-full h-full">
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="m4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
        ${text ? html`<p class="text-sm text-gray-600 font-medium">${text}</p>` : ''}
      </div>
    `;

    render(template, this);
  }
}

// Register the custom element
customElements.define('loading-spinner', LoadingSpinner);
